import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import AccountCircle from '@material-ui/icons/AccountCircle';

import { fmtDateTime, fmtInterval, fullName, isLessonLive } from './adminFormat';

// Column definitions for the Lessons tab: one row per teacher session.
// `id` is the sortField sent to /admin/lessons.

const durationCell = (val, row) => (
    <span>
        {fmtInterval(val)}
        {isLessonLive(row) ? (
            <strong style={{ marginLeft: 8, color: '#F5822C' }} title="Heartbeat still active">
                LIVE
            </strong>
        ) : null}
    </span>
);

export const lessonColumns = [
    {
        id: 'email',
        label: 'Teacher',
        render: (val, row) => (
            <span style={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0 }}>
                {row.avatar ? (
                    <Avatar src={row.avatar} style={{ width: 28, height: 28 }} />
                ) : (
                    <AccountCircle style={{ width: 28, height: 28, color: '#B5C4C6' }} />
                )}
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {val || '—'}
                    {fullName(row) ? <span style={{ color: '#5C7477' }}> · {fullName(row)}</span> : null}
                </span>
            </span>
        ),
    },
    { id: 'name', label: 'Class', render: (val, row) => val || row.classid },
    { id: 'studentcount', label: 'Students', numeric: true },
    { id: 'starttime', label: 'Started', render: (val) => fmtDateTime(val) },
    { id: 'duration', label: 'Duration', render: durationCell },
];
